import { NgModule } from '@angular/core';
import { ScrollWatchDirective } from './scroll-watch/scroll-watch';
import { SwipeDirective } from './swipe/swipe';
import { ImageViewerDirective } from './image-viewer/image-viewer';
import { WebComponentDirective } from './web-component/web-component';
import { OverlayDirective } from './overlay/overlay';
import { ContentResizeKeyboardDirective } from './content-resize-keyboard/content-resize-keyboard';
import { KeyboardNoAccessoryDirective } from './keyboard-no-accessory/keyboard-no-accessory';
import { LongPressDirective } from './long-press-directive/long-press-directive';

@NgModule({
  declarations: [
    ScrollWatchDirective,
    SwipeDirective,
    ImageViewerDirective,
    WebComponentDirective,
    OverlayDirective,
    ContentResizeKeyboardDirective,
    KeyboardNoAccessoryDirective,
    LongPressDirective,
  ],
  imports: [],
  exports: [
    ScrollWatchDirective,
    SwipeDirective,
    ImageViewerDirective,
    WebComponentDirective,
    OverlayDirective,
    ContentResizeKeyboardDirective,
    KeyboardNoAccessoryDirective,
    LongPressDirective,
  ],
})
export class DirectivesModule {}



// WEBPACK FOOTER //
// ./src/directives/directives.module.ts